import type { HistoryItem, GroupedItems } from './chatHistory.types';

export function formatHistoryDate(date: Date): string {
  const day = date.getDate();
  const month = date.toLocaleString('en-GB', { month: 'long' });
  const year = date.getFullYear();
  const time = date
    .toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true })
    .toUpperCase();
  return `${day} ${month} ${year} • ${time}`;
}

function isSameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function groupItems(items: HistoryItem[]): GroupedItems {
  const now = new Date();
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);

  return items.reduce<GroupedItems>(
    (acc, item) => {
      if (isSameDay(item.date, now)) {
        acc.today.push(item);
      } else if (isSameDay(item.date, yesterday)) {
        acc.yesterday.push(item);
      } else {
        acc.older.push(item);
      }
      return acc;
    },
    { today: [], yesterday: [], older: [] },
  );
}
